import type { FaireProductEntity } from "../../entity_types/product";

export const p_83nqu2qz8s: FaireProductEntity = {
  token: "p_83nqu2qz8s",
  type: "product",
  name: "Organic Elderberry Immune Tea",
  brandToken: "b_1q5xt82q",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d20cf800df3b2705e733e99fabdc0d86dbf2fc5c2961ff349445eb520e8516a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78d0960364330fb96fc9a9d7927debdbbaa58a384f40154b20f660a54d0f8db3.jpeg",
    "https://cdn.faire.com/fastly/48333a49b9c033dd1d46f83d4af68092be8a1b27f768d8dc5fb08f43cc7afe2a.jpeg",
    "https://cdn.faire.com/fastly/75a3a0b55e97e3bc3fad8dded2e0604168e5925c2790535d9e9740487bba1bf9.jpeg",
    "https://cdn.faire.com/fastly/0b7d2e953f671e0c606de29195e7b88b49d0da5d68700dcc11783fa23ee9da6e.jpeg",
    "https://cdn.faire.com/fastly/178062a015fe8d3344209544babff1527736f835209ce9e6d29fbfbf3279593c.jpeg",
    "https://cdn.faire.com/fastly/4ece8cb2fd6a15aa265336ae6bde94459e070f24302987034752a6543e584bb0.jpeg",
    "https://cdn.faire.com/fastly/b23399d2685116f11e02af13442ba9ae2c62428d7d0ca89be6a608dca66ad65e.jpeg",
  ],
  priceDollars: 4.67,
  description:
    "Earth Mama’s Organic Elderberry Immune Tea is packed with precisely blended herbs that support a healthy immune system. This delicious fruity herbal tea is USDA Certified Organic and safe for the whole family.\n\n * Safe for the whole family including kids, pregnant and breastfeeding people. \n * USDA Certified Organic by Oregon Tilth. \n * Non-GMO Project Verified and Certified Kosher by EarthKosher. \n * Each box contains 16 individually wrapped tea bags. \nPour 8 oz. of boiling water over one tea bag. Cover and steep at least 5-10 minutes. Squeeze teabag to release all the herbally goodness. Sip and enjoy!\n\n\n\n\n\n\n\nIngredients: Sambucus nigra (Elderberry) fruit*, Hibiscus sabdariffa flower*, Rosa canina (Rosehips)*, Stevia rebaudiana leaf*, Echinacea purpurea root*, Sambucus nigra (Elderberry) flower*, Aspalathus linearis (Rooibos) leaf*, Zingiber officinale (Ginger) root* *Organic\n",
  tags: [],
  msrpDollars: 9.34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:52.838Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
